import { OAUTH_SESSION_KEYS } from './constants';

/**
 * When the backend stops a not-yet-verified user mid-OAuth it redirects to
 * /kyc or /kyc/pending with a returnUrl pointing back at the interaction. The
 * KYC screens navigate internally, so the query param is stashed on entry and
 * consumed once verification lands.
 *
 * Kept separate from US_RETURN_URL / ROW_RETURN_URL: those belong to the login
 * journey, which reads them without clearing them.
 */
export const storeKycReturnUrl = (returnUrl) => {
  if (returnUrl) {
    sessionStorage.setItem(OAUTH_SESSION_KEYS.KYC_RETURN_URL, returnUrl);
  }
};

export const peekKycReturnUrl = () => sessionStorage.getItem(OAUTH_SESSION_KEYS.KYC_RETURN_URL);

export const takeKycReturnUrl = () => {
  const returnUrl = peekKycReturnUrl();
  sessionStorage.removeItem(OAUTH_SESSION_KEYS.KYC_RETURN_URL);

  return returnUrl;
};
